import { render, staticRenderFns } from "./CampaignMessageBody.vue?vue&type=template&id=7083a893&scoped=true"
import script from "./CampaignMessageBody.vue?vue&type=script&lang=js"
export * from "./CampaignMessageBody.vue?vue&type=script&lang=js"
import style0 from "./CampaignMessageBody.vue?vue&type=style&index=0&id=7083a893&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7083a893",
  null
  
)

export default component.exports